const KEY = "lh.listReturn";
const FLOW_ROUTES = new Set([
    "worklist",
    "appeal-detail",
    "intake-review",
    "qualify-order",
    "document-review-order",
    "check-my-coverage",
    "access-initiated-prior-auth",
    "create-submission",
    "pa-documents",
]);
/** Remember the Worklist URL, filters included, for this browser tab. */
export function rememberListReturn(path) {
    try {
        sessionStorage.setItem(KEY, path);
    }
    catch {
        return;
    }
}
/** Forget it: the user left the Worklist's flow, signed in or out, or changed company. */
export function forgetListReturn() {
    try {
        sessionStorage.removeItem(KEY);
    }
    catch {
        return;
    }
}
/** Any page outside the Worklist and the record pages it opens forgets it, so a later return never lands there. */
export function forgetListReturnOutsideFlow(routeName) {
    if (!FLOW_ROUTES.has(String(routeName)))
        forgetListReturn();
}
/** Where a finished action returns to: the remembered Worklist, else the page it returned to before. */
export function listReturnTarget(fallback) {
    try {
        return sessionStorage.getItem(KEY) || fallback;
    }
    catch {
        return fallback;
    }
}
